module.exports = __webpack_public_path__ + "static/media/32.471591b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/32.svg
// module id = 2823
// module chunks = 3